<script setup>
    import {
        Head
    } from '@vueuse/head'
</script>
<template>

    <Head>
        <title>{{ title }}</title>
        <meta name="description" :content="description">

        <!-- Social -->
        <meta property="og:title" :content="title">
        <meta property="og:description" :content="description">
        <!-- <meta property="og:image" content="https://picsum.photos/1200/675"> -->

        <!-- Twitter -->
        <meta name="twitter:title" :content="title">
        <meta name="twitter:description" :content="description">
        <!-- <meta name="twitter:image" content="https://picsum.photos/1200/675"> -->
        <!-- <meta name="twitter:card" content="summary_large_image"> -->
    </Head>
    <section class="py-10">
        <div class="container mt-5 mt-lg-10 text-white">
            <BreadcrumbsVue>
                <template v-slot:title>
                    Tools
                </template>
                <template v-slot:title-link>
                    Tools
                </template>
            </BreadcrumbsVue>
            <!-- align-items-center justify-content-between  -->
            <div class="row g-1 g-lg-2 mt-5">
                <h2>I enjoy building websites with open source toolkit. </h2>
                <p class="mb-5">I used to develop API's and totally loved it, but now I'm more into console commands and
                    backends too. I'm experimenting with some Laravel apps.</p>
                <div class="col-auto" v-for="( work , i) in works.tools" :key="i">
                    <div class="d-flex align-items-center border rounded-pill pe-4">
                        <!-- :src="work.tools_img" -->
                        <img :src="work.tools_img" width="72" height="72" class="me-3 rounded-circle" :alt="work.tools">
                        {{ work.tools }}
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    import BreadcrumbsVue from "../components/Breadcrumbs.vue"
    //   import WorkCardVue from "../components/WorkCard.vue"
    import works from '../../data/profile.json';
    export default {
        components: {
            BreadcrumbsVue,
            //  WorkCardVue
        },
        data: () => ({
            works,
            title : "Tools | Jethro Jorolan",
            description : "I used to develop API's and totally loved it, but now I'm more into console commands and backends too. I'm starting to experiment with some Laravel apps."
        }),
    }
</script>
